import loading from 'media/loading.svg'

export default function MediumLoadingComponent() {
    return (
        <div className="flex w-full h-32 items-center justify-center">
            <img src={loading} alt="Loading" className="spinner w-20 h-20" />
        </div>
    )
}
